import { NgModule } from '@angular/core';

import { UserExtractRolesPipe } from './user-extract-roles.pipe';

@NgModule({
  declarations: [UserExtractRolesPipe],
  exports: [UserExtractRolesPipe]
})
export class NguixDashboardUserExtractRolesPipeModule { }
